import { Component, ErrorType, fireLogEvent, fireStatusUpdate, Namespace, OneClickCommandNames, StatusTypes, SuccessText, UserActions } from '@chegg/commerce-utils';
import { ActionFailedMessage, OMActionType, RESTART_FAILED, RESUME_FAILED } from './constants';
import { FULL_MONTH_AND_DAY_AND_YEAR, getFormattedDate } from '../../utils/DateTimeUtil';
import { ORDERLINE_LOCKED } from '../../constants/appConstants';

//not sure why it is complaining even though tests they have been added
/* istanbul ignore next */
export var parseOrderManagementInfoWithCard = function parseOrderManagementInfoWithCard(_ref) {
  var text = _ref.text,
    price = _ref.price,
    _ref$renewalDate = _ref.renewalDate,
    renewalDate = _ref$renewalDate === void 0 ? '' : _ref$renewalDate,
    _ref$cardType = _ref.cardType,
    cardType = _ref$cardType === void 0 ? '' : _ref$cardType,
    _ref$last = _ref.last4,
    last4 = _ref$last === void 0 ? '' : _ref$last;
  return text.replace('${price}', price).replace('${card}', cardType.toUpperCase()).replace('${date}', getFormattedDate({
    dateISO: renewalDate,
    dateFormat: FULL_MONTH_AND_DAY_AND_YEAR
  })).replace('${last4digits}', last4);
};
export var parseOrderManagementInfoWithoutCard = function parseOrderManagementInfoWithoutCard(_ref2) {
  var text = _ref2.text,
    price = _ref2.price,
    _ref2$renewalDate = _ref2.renewalDate,
    renewalDate = _ref2$renewalDate === void 0 ? '' : _ref2$renewalDate,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? '' : _ref2$description;
  return text.replace('${price}', price).replace('${date}', getFormattedDate({
    dateISO: renewalDate,
    dateFormat: FULL_MONTH_AND_DAY_AND_YEAR
  })).replace('${description}', description);
};
export var parseOrderManagementInfoUpi = function parseOrderManagementInfoUpi(_ref3) {
  var text = _ref3.text,
    price = _ref3.price,
    _ref3$renewalDate = _ref3.renewalDate,
    renewalDate = _ref3$renewalDate === void 0 ? '' : _ref3$renewalDate,
    _ref3$vpa = _ref3.vpa,
    vpa = _ref3$vpa === void 0 ? '' : _ref3$vpa;
  var parsedText = text;
  var upiLogoIndex = text.indexOf('${img}');
  if (upiLogoIndex !== -1) {
    parsedText = "".concat(parsedText.slice(0, upiLogoIndex), " <br/> ").concat(parsedText.slice(upiLogoIndex));
  }
  parsedText = parsedText.replace('${price}', price).replace('${date}', getFormattedDate({
    dateISO: renewalDate,
    dateFormat: FULL_MONTH_AND_DAY_AND_YEAR
  })).replace('${vpa}', vpa).replace('${img}', '<img style="vertical-align: middle; margin-right: 10px" src="https://c.cheggcdn.com/assets/site/icons/upi-logo.png" alt="upi-logo"/>');
  return parsedText;
};
export var parseButtonConditionsData = function parseButtonConditionsData(text) {
  var cta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var price = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return text.split('${cta}').join(cta).split('${price}').join(price);
};
export var getParsedButtonConditionsText = function getParsedButtonConditionsText(data) {
  var content = data.content,
    cta = data.cta,
    price = data.price;
  {
    return parseButtonConditionsData(content.buttonConditions, cta.cta, price);
  }
};
export var getParsedOrderManagementText = function getParsedOrderManagementText(data) {
  var paymentAccountType = data.paymentAccountType,
    content = data.content,
    price = data.price,
    renewalDate = data.renewalDate,
    cardType = data.cardType,
    last4 = data.last4,
    description = data.description,
    vpa = data.vpa;
  switch (paymentAccountType) {
    case 'CREDIT_CARD_TOKEN':
      return parseOrderManagementInfoWithCard({
        text: content.orderManagementInfo,
        price: price,
        renewalDate: renewalDate,
        cardType: cardType,
        last4: last4
      });
    case 'GIFT_CODE':
      return parseOrderManagementInfoWithoutCard({
        text: content.orderManagementInfoYiftee,
        price: price,
        renewalDate: renewalDate
      });
    case 'UPI':
      return parseOrderManagementInfoUpi({
        text: content.orderManagementInfoUpi,
        price: price,
        renewalDate: renewalDate,
        vpa: vpa
      });
    default:
      return parseOrderManagementInfoWithoutCard({
        text: content.orderManagementInfoNonCreditCard,
        price: price,
        renewalDate: renewalDate,
        description: description
      });
  }
};
export var getRioErrorCallback = function getRioErrorCallback(action) {
  return function (logObj) {
    fireLogEvent(logObj, Namespace.ONE_CLICK);
    fireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: action === OMActionType.RESUME ? OneClickCommandNames.RESUME_ORDER : OneClickCommandNames.RESTART_ORDER,
      payload: {
        component: Component.ORDER_MANAGEMENT,
        errors: [{
          message: action === OMActionType.RESUME ? RESUME_FAILED : RESTART_FAILED,
          type: ErrorType.SERVER
        }]
      }
    }], Namespace.ONE_CLICK);
  };
};
export var getRioSuccessCallback = function getRioSuccessCallback(action) {
  return function (logObj) {
    fireLogEvent(logObj, Namespace.ONE_CLICK);
    fireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: action === OMActionType.RESUME ? OneClickCommandNames.RESUME_ORDER : OneClickCommandNames.RESTART_ORDER,
      payload: {
        component: Component.ORDER_MANAGEMENT,
        data: {
          action: action
        }
      }
    }], Namespace.ONE_CLICK);
  };
};
export var getOMActionType = function getOMActionType(action) {
  return action === UserActions.RESUME || action === UserActions.REVOKE_PENDING_PAUSE ? OMActionType.RESUME : OMActionType.UNDOCANCEL;
};
export var getFailedActionMessage = function getFailedActionMessage(action) {
  return action === UserActions.RESUME || action === UserActions.REVOKE_PENDING_PAUSE ? ActionFailedMessage.RESUME : ActionFailedMessage.UNDOCANCEL;
};
export var getSuccessText = function getSuccessText(action) {
  return action === UserActions.RESUME || action === UserActions.REVOKE_PENDING_PAUSE ? SuccessText.SUBSCRIPTION_RESUMED : SuccessText.SUBSCRIPTION_RESTART;
};
export var isSubscriptionLocked = function isSubscriptionLocked(response) {
  var _response$errors$, _response$errors$2;
  return ((_response$errors$ = response.errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.code) === 'CSDK-000' && ((_response$errors$2 = response.errors[0]) === null || _response$errors$2 === void 0 || (_response$errors$2 = _response$errors$2.originalError) === null || _response$errors$2 === void 0 ? void 0 : _response$errors$2.extensions.response.body.errors[0].errorCode) === ORDERLINE_LOCKED;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OrderManagement/helper.js
// module id = 4717
// module chunks = 11